import { createBrowserRouter, createHashRouter } from 'react-router-dom';
import { RootLayout, AuthLayout, GuestLayout } from './layouts';
import {
  HomePage,
  LoginPage,
  RegisterPage,
  ProfilePage,
  LeaderboardPage,
  SettingsPage,
  SinglePlayerSetupPage,
  MultiplayerPage,
  GamePage,
  NotFoundPage,
} from './pages';

const routes = [
  {
    element: <RootLayout />,
    children: [
      // Guest-only routes (redirect if already logged in)
      {
        element: <GuestLayout />,
        children: [
          { path: '/login', element: <LoginPage /> },
          { path: '/register', element: <RegisterPage /> },
        ],
      },

      // Protected routes (redirect to login if not authenticated)
      {
        element: <AuthLayout />,
        children: [
          { path: '/', element: <HomePage /> },
          { path: '/profile', element: <ProfilePage /> },
          { path: '/settings', element: <SettingsPage /> },
          { path: '/play/single', element: <SinglePlayerSetupPage /> },
          { path: '/play/multiplayer', element: <MultiplayerPage /> },
          { path: '/game/:roomCode', element: <GamePage /> },
        ],
      },

      // Public routes
      { path: '/leaderboard', element: <LeaderboardPage /> },

      // 404
      { path: '*', element: <NotFoundPage /> },
    ],
  },
];

// itch.io, Poki, CrazyGames, and Facebook Instant Games all serve the app
// from a deep/CDN URL path (e.g. /html/NNNNN/index.html) which breaks
// createBrowserRouter's basename resolution. Hash routing sidesteps this by
// using #/ for navigation instead of the URL pathname.
const EMBED_MODES = ['itch', 'poki', 'crazygames', 'fb'];

export const router = EMBED_MODES.includes(import.meta.env.MODE)
  ? createHashRouter(routes)
  : createBrowserRouter(routes, { basename: import.meta.env.BASE_URL });
